import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ColumnConfig } from '../../../core/contract/user-configuration/column-config.contract';
import { TableColumn } from '../../../osp-ui/components/data/table/contract/table-column.contract';
import { PAGEABLE_DATASOURCE_DEFAULT_PAGE_SIZE } from '../../../shared/constants/pageable-datasource.const';
import { SearchUser } from '../contract/search-user.contract';
import { ViewUser } from '../contract/view-user.contract';

@Injectable({ providedIn: 'root' })
export class UserListConfigService {
  private readonly DEFAULT_PAGE_SIZE = 25;
  public readonly availableColumns: TableColumn<ViewUser>[] = [];

  private _selectedColumnKeys$ = new BehaviorSubject<string[]>([]);
  private _pageSize$ = new BehaviorSubject<number>(PAGEABLE_DATASOURCE_DEFAULT_PAGE_SIZE);
  private _onClickDetails$ = new Subject<SearchUser>();

  public readonly contentEmitters = {
    onClickDetails: this._onClickDetails$.asObservable(),
  };

  get pageSize(): number {
    return this._pageSize$.getValue();
  }

  constructor() {
    this.initConfigs();
  }

  savePageSize(size: number): void {
    if (size && size !== this.pageSize) {
      this._pageSize$.next(size);
    }
  }

  saveColumnConfigs(config: ColumnConfig): void {
    this.mergeColumns([config]);
  }

  getColumn(columnKey: string): TableColumn<ViewUser> | null {
    return this.availableColumns.find(({ key }) => columnKey === key) || null;
  }

  private initConfigs(): void {
    this._pageSize$.next(this.DEFAULT_PAGE_SIZE);
    const columnKeys = this.availableColumns.map((col) => col.key);
    this._selectedColumnKeys$.next(columnKeys);
  }

  private mergeColumns(columnConfigs: ColumnConfig[]): void {
    (columnConfigs ?? []).forEach(({ name, width }) => {
      const foundColumn = this.getColumn(name);
      if (foundColumn && foundColumn.hardcoded !== true) {
        foundColumn.widthPx = width;
      }
    });
  }
}
